import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { apiClient } from '../../api/client';

const WelcomeCard = () => {
  const navigate = useNavigate();

  // CR-11 EXT: if the teen has an active 20-challenge journey, route them
  // into Practice with that challenge_id so the session binds to a
  // challenge_run. Otherwise fall back to freestyle Practice (unchanged).
  const handleStart = async () => {
    try {
      const cur = await apiClient.request('/api/schools/journey/current');
      if (cur && cur.has_journey && cur.challenge_id) {
        navigate(`/conversations?challenge_id=${encodeURIComponent(cur.challenge_id)}`);
        return;
      }
    } catch (_e) { /* non-fatal — fall through to freestyle */ }
    navigate('/conversations');
  };

  return (
    <div
      className="card animate-slideUp"
      style={{
        background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 40%, #FCD34D 100%)',
        border: 'none',
        position: 'relative',
        overflow: 'hidden',
      }}
      data-testid="welcome-card"
    >
      <div style={{ position: 'absolute', top: -20, right: -20, opacity: 0.1 }}>
        <Sparkles size={120} />
      </div>
      <div className="relative z-10">
        <div className="flex items-center gap-2 mb-3">
          <Sparkles size={20} className="text-amber-700" />
          <h3 className="text-lg font-bold text-amber-900">Welcome to HiBFF!</h3>
        </div>
        <p className="text-sm text-amber-800 mb-4 leading-relaxed">
          This is your safe space to practise social skills with your personal AvA trainer.
          Start a conversation to begin building confidence!
        </p>
        <button
          onClick={handleStart}
          className="flex items-center gap-2 px-4 py-2.5 bg-amber-900 text-white rounded-xl text-sm font-semibold hover:bg-amber-800 transition-all hover:translate-x-1"
          data-testid="welcome-card-start-btn"
        >
          Start Your First Practice
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default WelcomeCard;
